import ModalBody from '@/components/Modal/common/ModalBody';
import ModalTitleCard from '@/components/Modal/common/ModalTitleCard';
import { handleApiValidationErrors } from '@/helpers/form';
import { Button, Modal } from '@mui/material';
import axios from 'axios';
import PropTypes from 'prop-types';
import { FormProvider } from 'react-hook-form';
import { toast } from 'react-toastify';
import AddNewUserAvatar from '../../Icons/AddNewUserAvatar';
import AccessManagement from '../Components/AccessManagement';
import AdditionalControls from '../Components/AdditionalControls';
import CampaignsApprovalSelect from '../Components/CampaignsApprovalSelect';
import UserInfo from '../Components/UserInfo';
import { createUser, getAllowedScreenKeys, isScreenAccessSubmitDisabled } from '../data/userService';

const AddNewUserModal = ({
  open,
  handleClose,
  meRole,
  setLoading,
  formMethods,
  userRole,
  onModalClose,
  screensByRole,
}) => {
  const { handleSubmit, reset, setError, clearErrors } = formMethods;

  // undefined means screensByRole hasn't loaded an entry for this role yet —
  // block submit rather than let getScreens fall through to "no filter".
  const allowedScreenKeys = getAllowedScreenKeys(screensByRole, userRole);

  const onSubmit = async data => {
    setLoading(true);
    clearErrors();
    try {
      await createUser(data, getAllowedScreenKeys(screensByRole, data.userRole));
      setLoading(false);

      handleClose(true);
      toast.success('User created successfully');

      reset();
    } catch (error) {
      setLoading(false);
      if (axios.isAxiosError(error) && error.response?.data?.errors?.length) {
        handleApiValidationErrors(error.response.data.errors, setError);
      } else {
        toast.error('Something went wrong');
      }
    }
  };

  return (
    <Modal open={open} onClose={onModalClose} aria-labelledby='modal-title'>
      <ModalBody
        sx={{
          width: '800px',
          maxWidth: '90vw',
        }}
      >
        <ModalTitleCard titleIcon={<AddNewUserAvatar />} handleClose={onModalClose} title='Add New User' />
        <FormProvider {...formMethods}>
          <form className='mt-4' onSubmit={handleSubmit(onSubmit)}>
            <UserInfo meRole={meRole} />
            <AdditionalControls userRole={userRole} meRole={meRole} />
            <AccessManagement userRole={userRole} meRole={meRole} />
            <CampaignsApprovalSelect userRole={userRole} />
            <hr className='-mx-[32px] my-5' />
            <div className='mt-5 flex justify-end gap-[12px]'>
              <Button color='inherit' variant='outlined' onClick={onModalClose}>
                Cancel
              </Button>
              <Button
                color='primary'
                variant='contained'
                type='submit'
                disabled={isScreenAccessSubmitDisabled(allowedScreenKeys)}
              >
                Invite User
              </Button>
            </div>
          </form>
        </FormProvider>
      </ModalBody>
    </Modal>
  );
};

AddNewUserModal.propTypes = {
  open: PropTypes.bool,
  handleClose: PropTypes.func,
  meRole: PropTypes.number,
  setLoading: PropTypes.func,
  formMethods: PropTypes.object,
  userRole: PropTypes.number,
  onModalClose: PropTypes.func,
  screensByRole: PropTypes.object,
};

export default AddNewUserModal;
